import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

const GoogleTag = () => {
  const location = useLocation();
  const { pathname, search, hash } = location;

  // 初回のみ GTM + GA4 を読み込む
  useEffect(() => {
    if (!document.getElementById('googleTagManager')) {
      const script = document.createElement('script');
      script.id = 'googleTagManager';
      script.type = 'text/javascript';
      script.setAttribute('data-cfasync', 'false');
      script.setAttribute('data-pagespeed-no-defer', '');
      script.innerHTML = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NKR5LRD8');
      `;
      document.head.appendChild(script);
    }

    if (!document.getElementById('ga4')) {
      const script2 = document.createElement('script');
      script2.id = 'ga4';
      script2.async = true;
      script2.src = 'https://www.googletagmanager.com/gtag/js?id=G-CHJVSXW7S5';
      document.head.appendChild(script2);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-CHJVSXW7S5');
      `;
      document.head.appendChild(inlineScript);
    }
  }, []);

  // URL の変更時に gtag の page_path を送信
  useEffect(() => {
    const fullPath = pathname + search + hash;
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-CHJVSXW7S5', {
        page_path: fullPath
      });
    }
  }, [pathname, search, hash]);

  return (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-NKR5LRD8"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      ></iframe>
    </noscript>
  );
};

export default GoogleTag;
